module.exports = __webpack_public_path__ + "assets/ic_arrow_right5.e33213df.svg";